<template>
    <!--Duy edit 06/02/2024-->
    <div class="form-group">
        <label v-if="title && title.trim().length > 0" :class="{ cursor: !!onTitleClick }" @click="handleTitleClick"
            :title="tooltipText">
            {{ title }} <span class="text-danger">{{ isRequire ? '(*)' : '' }}</span>
        </label>
        <textarea :id="idInput" v-if="isMultipleLine && !isSummerNote" autocomplete="off" type="text" class="form-control"
            :placeholder="placeholder" v-model="model" :readonly="isReadOnly || false" @change="onChange"
            :class="{ 'is-invalid': error }" rows="2"></textarea>
        <input :id="idInput" ref="input" v-else-if="!isMultipleLine && !isSummerNote" autocomplete="off" type="text"
            class="form-control" :placeholder="placeholder" v-model="model" :readonly="isReadOnly || false"
            @change="onChange" :class="{ 'is-invalid': error }" />
        <textarea :id="idInput" v-else autocomplete="off" type="text" class="form-control" :placeholder="placeholder"
            v-model="model" :readonly="isReadOnly || false" @change="onChange" :class="{ 'is-invalid': error }"
            rows="2"></textarea>
        <div class="text-danger text-right" v-if="error">
            {{ error }}
        </div>

    </div>
</template>

<script>
import { ref, toRefs, watch } from "vue";
import $ from 'jquery';
export default {
    name: "TheInputText",
    props: {
        title: String,
        initialValue: {
            type: [String, Number],
            default: '',
        },
        placeholder: String,
        error: String,
        isReadOnly: Boolean,
        isRequire: Boolean,
        isMultipleLine: Boolean,
        isSummerNote: Boolean,
        onTitleClick: Function,
        tooltipText: String
    },
    data() {
        return {
            idInput: '_' + Math.random().toString(36).substr(2, 9),
        }
    },
    methods: {
        onChange(e) {
            this.$emit('update:modelValue', e.target.value)
            this.$emit('onChange', e.target.value)
        },

        handleTitleClick() {
            if (this.onTitleClick) {
                this.onTitleClick();
            }
        }
    },
    computed: {
        parsedInitialValue() {
            return String(this.initialValue);
        },
    },
    async mounted() {
        if (this.isSummerNote) {
            const pickerSelector = `#${this.idInput}`;
            $(pickerSelector).summernote({
                height: 200,
                toolbar: [
                    // [groupName, [list of button]]
                    ['style', ['bold', 'italic', 'underline', 'clear']],
                    ['font', ['superscript', 'subscript', 'fontname']],
                    //'strikethrough',
                    ['fontsize', ['fontsize', 'fontsizeunit']],
                    ['color', ['color']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    //['height', ['height']]
                ],
                fontSizes: ['8', '9', '10', '11', '12', '13', '14', '15', '16', '18', '20', '22', '24', '28', '32', '36', '40', '48'],
                disableDragAndDrop: true,
                callbacks: {
                    onChange: (contents) => {
                        this.model = contents;
                        this.$emit('update:modelValue', contents);
                    },
                    onPaste: function (e) {
                        const clipboardData = (e.originalEvent || e).clipboardData;
                        const items = clipboardData.items;
                        let isImage = false;

                        for (let i = 0; i < items.length; i++) {
                            if (items[i].type.indexOf('image') !== -1) {
                                isImage = true;
                                break;
                            }
                        }

                        if (isImage) {
                            e.preventDefault();
                            alert('Dán hình ảnh bị chặn.');
                        }
                        else {
                            // Xử lý font sau khi dán văn bản
                            setTimeout(function () {
                                $(pickerSelector).summernote('code', `<div style="font-family: Arial; font-size: 16px;">${$(pickerSelector).summernote('code')}</div>`);
                            }, 10);
                        }
                    },
                    onImageUpload: function (files) {
                        // Ngăn chặn việc upload hình ảnh
                        alert('Tính năng tải hình ảnh đã bị vô hiệu hóa.');
                    }
                }
            });
            // $(pickerSelector).summernote('disable');
            $(pickerSelector).summernote('code', this.model);
            $(pickerSelector).summernote('fontSize', 16);

            // $(pickerSelector).summernote('font-family', 'Source Sans Pro');
            $(pickerSelector).summernote('fontName', 'Arial');
            $(pickerSelector).css('font-family', 'Arial');

            $(pickerSelector).on('paste', function (e) {
                $(pickerSelector).summernote('formatPara', {
                    font: 'Source Sans Pr',
                    fontSize: '16px' // Hoặc kích cỡ font bạn mong muốn
                });
            });

        }
    },
    setup(props) {

        const model = ref(props.initialValue);
        watch(() => props.initialValue, (newVal) => {
            model.value = newVal;
        });

        return { model };
    },
}
</script>